import {RemotePatchCommunication} from 'data/usecases/private/communications/remote-patch-communication';
import {PatchCommunication} from 'domain/usecases/private/communications/patch-communication';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {StubPatchCommunication} from 'data/usecases/private/communications/stub-patch-communication';
import {StubPatchCommunicationWithBadRequestError} from 'data/usecases/private/communications/stub-patch-communication-with-bad-request-error';
import {StubPatchCommunicationWithNotFoundError} from 'data/usecases/private/communications/stub-patch-communication-with-not-found-error';
import {communicationsFlowEndpoints} from '../../endpoints';

export const makePatchCommunication = (): PatchCommunication =>
	new RemotePatchCommunication(
		makeBFFApiUrl(communicationsFlowEndpoints.confirmation),
		makeAuthorizeHttpClientDecorator(),
	);

export const mockedMakePatchCommunication = (): PatchCommunication => new StubPatchCommunication();

export const mockedMakePatchCommunicationWithBadRequestError = (): PatchCommunication =>
	new StubPatchCommunicationWithBadRequestError();

export const mockedMakePatchCommunicationWithNotFoundError = (): PatchCommunication =>
	new StubPatchCommunicationWithNotFoundError();
